export default "__VITE_ASSET__CCQ8HECi__"